<div
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full mb-2"
>
  <ts-input
    [label]="fieldDef.label"
    [testId]="'form-field-' + fieldDef.name"
    [formControl]="control"
    (click)="edit()"
    (keyup.enter)="onBlur()"
    (blur)="onBlur()"
  />
</div>
